import React from "react";
import whiteBook from "../assets/images/mockup-guide.png";
import { FaChevronRight } from "react-icons/fa6";

function WhiteBookRelai() {

	return (
		<div className="whiteBook">
			<div className="whiteBook__left-container">
				<h2 className="whiteBook__title">
					Parlons règles
					<strong>
						<i> à l'école</i>
					</strong>
				</h2>
				<p className="whiteBook__text">
					Vous souhaitez aborder la question des règles mais vous ne savez pas quand et comment ? En classe ou individuellement ? Vous voulez monter un projet dans votre établissement autour des règles ?
				</p>
				<p className="whiteBook__text">
					Cette plateforme est conçue pour donner de l’information aux plus jeunes mais aussi pour donner des conseils aux relais éducatifs (enseignant·es, AED, AESH, CPE, animateur·ices…)  pour aborder la question des règles.
				</p>
				<p className="whiteBook__text">
					“Parlons règles à l’école” est le premier guide pour repérer, anticiper les situations et accompagner les jeunes dans la connaissance de leur propre corps, ainsi que du corps de l’autre, pour favoriser le mieux être et le vivre ensemble.
				</p>
			</div>
			<div className="whiteBook__right-container">
				<div className="whiteBook__img-container">
					<img className="whiteBook__img" src={whiteBook} alt="" aria-hidden="true" />
				</div>
				<a className="whiteBook__download-button focused" href="https://doccollectes.blob.core.windows.net/parlons-regles/guide_parlons_regles_a_lecole.pdf" target="_blank" rel="noreferrer">
					Télécharger le guide{" "}
					<FaChevronRight className="partners-footer__chevron" />
				</a>
			</div>
		</div>
	);
}

export default WhiteBookRelai;
